import React, { useEffect, useState } from "react";
import {
  getJimbos,
  createJimbo,
  getParokia,
  updateJimbo,
} from "../../services/api";
import ParokiaModal from "./ParokiaModal";
import "./hierarchy.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const REGIONS = [
  "Dar es Salaam",
  "Arusha",
  "Dodoma",
  "Mwanza",
  "Mbeya",
  "Morogoro",
  "Tanga",
  "Kilimanjaro",
  "Pwani",
];

export default function JimboPage() {
  const [jimbos, setJimbos] = useState([]);
  const [loading, setLoading] = useState(false);

  const [createOpen, setCreateOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [selectedJimbo, setSelectedJimbo] = useState(null);
  const [parokia, setParokia] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);

  const initialForm = {
    name: "",
    region: "",
    address: "",
    city: "",
    district: "",
    postal_code: "",
    country: "Tanzania",
    bishop_name: "",
    bishop_phone: "",
    bishop_email: "",
    bishop_appointed_date: "",
    bishop_status: "ACTIVE",
    official_email: "",
    official_phone: "",
    website: "",
    status: "ACTIVE",
  };

  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    loadJimbos();
  }, []);

  const loadJimbos = async () => {
    setLoading(true);
    try {
      const data = await getJimbos();
      setJimbos(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Load Jimbos error", err);
    }
    setLoading(false);
  };

  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });
  };

  const handleCreate = async () => {
  const confirm = window.confirm("Are you sure you want to create this Jimbo?");
  if (!confirm) return;

  try {
    const payload = sanitizeForm(form);
    await createJimbo(payload);
    setCreateOpen(false);
    setForm(initialForm);
    loadJimbos();
    toast.success("Jimbo created successfully!");
  } catch (err) {
    console.error("Create Jimbo error", err);
    toast.error("Failed to create Jimbo.");
  }
};

const handleUpdate = async () => {
  const confirm = window.confirm("Are you sure you want to save changes?");
  if (!confirm) return;

  try {
    const payload = sanitizeForm(form);
    await updateJimbo(selectedJimbo.jimbo_id, payload);
    setEditMode(false);
    setViewOpen(false);
    loadJimbos();
    toast.success("Jimbo updated successfully!");
  } catch (err) {
    console.error("Update Jimbo error", err);
    toast.error("Failed to update Jimbo.");
  }
};

  // Ensure empty strings become null for backend
  const sanitizeForm = (f) => ({
    name: f.name,
    region: f.region || null,
    address: f.address || null,
    city: f.city || null,
    district: f.district || null,
    postal_code: f.postal_code || null,
    country: f.country || "Tanzania",
    bishop_name: f.bishop_name || null,
    bishop_phone: f.bishop_phone || null,
    bishop_email: f.bishop_email || null,
    bishop_appointed_date: f.bishop_appointed_date ? f.bishop_appointed_date.split("T")[0] // Only YYYY-MM-DD
    : null,
    bishop_status: f.bishop_status || "ACTIVE",
    official_email: f.official_email || null,
    official_phone: f.official_phone || null,
    website: f.website || null,
    status: f.status || "ACTIVE",
  });

  const openView = (jimbo) => {
    setSelectedJimbo(jimbo);
    setForm({ ...initialForm, ...jimbo });
    setEditMode(false);
    setViewOpen(true);
  };

  const openParokia = async (jimbo) => {
    setSelectedJimbo(jimbo);
    setModalOpen(true);
    setModalLoading(true);
    try {
      const res = await getParokia(jimbo.jimbo_id);
      setParokia(res.data || []);
    } catch {
      setParokia([]);
    }
    setModalLoading(false);
  };

  const closeModal = () => {
    setCreateOpen(false);
    setViewOpen(false);
    setEditMode(false);
    setForm(initialForm);
  };

  const renderFormFields = () => (
    <>
      <div className="modal-section">
        <h4>Basic Information</h4>
        <div className="form-grid">
          <input
            className="input"
            placeholder="Name"
            value={form.name}
            onChange={(e) => handleChange("name", e.target.value)}
          />
          <select
            className="input"
            value={form.region}
            onChange={(e) => handleChange("region", e.target.value)}
          >
            <option value="">Select Region</option>
            {REGIONS.map((r) => (
              <option key={r}>{r}</option>
            ))}
          </select>
          <input
            className="input"
            placeholder="Address"
            value={form.address}
            onChange={(e) => handleChange("address", e.target.value)}
          />
          <input
            className="input"
            placeholder="City"
            value={form.city}
            onChange={(e) => handleChange("city", e.target.value)}
          />
          <input
            className="input"
            placeholder="District"
            value={form.district}
            onChange={(e) => handleChange("district", e.target.value)}
          />
          <input
            className="input"
            placeholder="Postal Code"
            value={form.postal_code}
            onChange={(e) => handleChange("postal_code", e.target.value)}
          />
          <input
            className="input"
            placeholder="Country"
            value={form.country}
            onChange={(e) => handleChange("country", e.target.value)}
          />
          {/* <select
            className="input"
            value={form.status}
            onChange={(e) => handleChange("status", e.target.value)}
          >
            <option value="ACTIVE">ACTIVE</option>
            <option value="INACTIVE">INACTIVE</option>
          </select> */}
        </div>
      </div>

      <div className="modal-section">
        <h4>Bishop Information</h4>
        <div className="form-grid">
          <input
            className="input"
            placeholder="Bishop Name"
            value={form.bishop_name}
            onChange={(e) => handleChange("bishop_name", e.target.value)}
          />
          <input
            className="input"
            placeholder="Phone"
            value={form.bishop_phone}
            onChange={(e) => handleChange("bishop_phone", e.target.value)}
          />
          <input
            className="input"
            placeholder="Email"
            value={form.bishop_email}
            onChange={(e) => handleChange("bishop_email", e.target.value)}
          />
          <input
            type="date"
            className="input"
            placeholder="Select appointed date"
            value={form.bishop_appointed_date || ""}
            onChange={(e) =>
              handleChange("bishop_appointed_date", e.target.value)
            }
          />
          {/* <select
            className="input"
            value={form.bishop_status}
            onChange={(e) => handleChange("bishop_status", e.target.value)}
          >
            <option value="ACTIVE">ACTIVE</option>
            <option value="RETIRED">RETIRED</option>
          </select> */}
        </div>
      </div>

      <div className="modal-section">
        <h4>Official Contacts</h4>
        <div className="form-grid">
          <input
            className="input"
            placeholder="Official Email"
            value={form.official_email}
            onChange={(e) => handleChange("official_email", e.target.value)}
          />
          <input
            className="input"
            placeholder="Official Phone"
            value={form.official_phone}
            onChange={(e) => handleChange("official_phone", e.target.value)}
          />
          <input
            className="input"
            placeholder="Website"
            value={form.website}
            onChange={(e) => handleChange("website", e.target.value)}
          />
        </div>
      </div>
    </>
  );

  const renderViewInfo = () => (
    <div className="form-grid" style={{ gap: "14px" }}>
      <div>
        <p><strong>Name:</strong> {selectedJimbo?.name || "-"}</p>
        <p><strong>Region:</strong> {selectedJimbo?.region || "-"}</p>
        <p><strong>Address:</strong> {selectedJimbo?.address || "-"}</p>
        <p><strong>City:</strong> {selectedJimbo?.city || "-"}</p>
        <p><strong>District:</strong> {selectedJimbo?.district || "-"}</p>
        <p><strong>Postal Code:</strong> {selectedJimbo?.postal_code || "-"}</p>
        <p><strong>Country:</strong> {selectedJimbo?.country || "-"}</p>
        {/* <p><strong>Status:</strong> {selectedJimbo?.status || "-"}</p> */}
      </div>
      <div>
        <p><strong>Bishop Name:</strong> {selectedJimbo?.bishop_name || "-"}</p>
        <p><strong>Bishop Phone:</strong> {selectedJimbo?.bishop_phone || "-"}</p>
        <p><strong>Bishop Email:</strong> {selectedJimbo?.bishop_email || "-"}</p>
        <p><strong>Bishop Appointed:</strong> {selectedJimbo?.bishop_appointed_date || "-"}</p>
        {/* <p><strong>Bishop Status:</strong> {selectedJimbo?.bishop_status || "-"}</p> */}
        <p><strong>Official Email:</strong> {selectedJimbo?.official_email || "-"}</p>
        <p><strong>Official Phone:</strong> {selectedJimbo?.official_phone || "-"}</p>
        <p><strong>Website:</strong> {selectedJimbo?.website || "-"}</p>
      </div>
    </div>
  );

  return (
    <div className="page-container">
      <div className="hierarchy-header">
        <div>
          <h1>Jimbo Management</h1>
          <p className="subtitle">Manage dioceses (Jimbo)</p>
        </div>
        <button className="btn primary" onClick={() => setCreateOpen(true)}>
          + New Jimbo
        </button>
      </div>

      <div className="card">
        {loading ? (
          <div className="spinner" />
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Region</th>
                <th>Bishop</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {jimbos.map((j, i) => (
                <tr key={j.jimbo_id}>
                  <td>{i + 1}</td>
                  <td className="bold">{j.name}</td>
                  <td>{j.region}</td>
                  <td>{j.bishop_name}</td>
                  <td>
                    <span className="badge-success">{j.status}</span>
                  </td>
                  <td>
                    <button className="btn small btn-green" onClick={() => openView(j)}>View</button>
                    <button className="btn small btn-green" style={{ marginLeft: 8 }} onClick={() => openParokia(j)}>Parokia</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {(createOpen || viewOpen) && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-close" onClick={closeModal} title="Close">✕</div>
            <h3>{createOpen ? "Create Jimbo" : editMode ? "Edit Jimbo" : selectedJimbo?.name}</h3>

            <div
              style={{
                maxHeight: "70vh",
                overflowY: createOpen || editMode || viewOpen ? "auto" : "visible",
                paddingRight: createOpen || editMode || viewOpen ? "8px" : "0",
              }}
            >
              {(createOpen || editMode) ? renderFormFields() : renderViewInfo()}
            </div>

            <div className="modal-actions">
              {!createOpen && !editMode && (
                <button className="btn" onClick={() => setEditMode(true)}>Edit</button>
              )}
              <button className="btn" onClick={closeModal}>Cancel</button>
              {(createOpen || editMode) && (
                <button className="btn primary" onClick={createOpen ? handleCreate : handleUpdate}>
                  {createOpen ? "Create" : "Save Changes"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {modalOpen && (
        <ParokiaModal
          jimbo={selectedJimbo}
          parokia={parokia}
          loading={modalLoading}
          onClose={() => setModalOpen(false)}
        />
      )}
      <ToastContainer 
      position="top-right" 
      autoClose={3000} 
      hideProgressBar={false} 
      newestOnTop={false} 
      closeOnClick 
      rtl={false} 
      pauseOnFocusLoss 
      draggable 
      pauseOnHover
    />
    </div>
    
  );
  
}

